export default __webpack_public_path__ + "5f744a0fc31beae95373575b75ba8aa3.png";